export const validateForm = (form, validations, callback) => {
  const errors = [];

  if (!Array.isArray(validations) || validations.length === 0) {
    if (typeof callback === 'function') callback(errors);
    return errors;
  }

  validations.forEach((item) => {
    const label = item?.label ?? '';
    const field = item?.field || label; // allow using label as field when field not provided
    const value = form ? form[field] : undefined;

    // Normalize rules: accept either item.rules (array) or a single flat item as a rule
    const normalizedRules =
      Array.isArray(item?.rules) && item.rules.length > 0 ? item.rules : [item];

    // Saving first error in onlu field
    let hasError = false;

    for (const rule of normalizedRules) {
      if (hasError) break;

      const message = rule?.message || 'Invalid value';

      // Required check
      if (rule?.required) {
        const empty = value === undefined || value === null || value === '';
        if (empty) {
          errors.push({ label, message });
          hasError = true;
          continue;
        }
      }

      // Regex / pattern check (only when value is present)
      const pattern = rule?.regex || rule?.pattern;
      if (
        pattern instanceof RegExp &&
        value !== undefined &&
        value !== null &&
        value !== ''
      ) {
        if (!pattern.test(String(value))) {
          errors.push({ label, message });
          hasError = true;
          continue;
        }
      }

      // Min/Max length checks (optional)
      if (typeof rule?.min === 'number' && value) {
        if (String(value).length < rule.min) {
          errors.push({ label, message });
          hasError = true;
          continue;
        }
      }
      if (typeof rule?.max === 'number' && value) {
        if (String(value).length > rule.max) {
          errors.push({ label, message });
          hasError = true;
          continue;
        }
      }

      // Custom validator (sync only in this helper)
      if (typeof rule?.validator === 'function') {
        const res = rule.validator(value, form);
        if (res === false) {
          errors.push({ label, message });
          hasError = true;
          continue;
        }
        if (typeof res === 'string') {
          errors.push({ label, message: res });
          hasError = true;
          continue;
        }
      }
    }
  });

  if (typeof callback === 'function') {
    callback(errors);
  }

  return errors;
};
